import React from "react";
import PureComponent from "../../pure";

import Button from "../../formElements/Button";
import Loader from "../../loader";
import sAction from 'sAction';

export default class FileDownload extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    var data = this.props.data;
    const state = data.get("state");
    const link = sAction.param.files + "downloadFile/" + data.get("token");
    
    return (
      <div className="fileDownload">
        {state == "load" && <Loader />}
        {state == "init" && (
          <React.Fragment>
            <div className="popupDownloadButton icon-download" data-test={window.Cypress && link}
              onClick={() => {
                window.open(link, "_blank");
                sAction.popupHide();
              }
              }
            >
            </div>
            <span>{sAction.translate("LBL_DOWNLOAD_FILE", "Documents")}</span>
          </React.Fragment>
        )}
      </div>
    );
  }
}
